import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";
import { get } from "lodash";

import { groupsMapNestedRows, collabGroupsMapNestedRows, hasBrokerAccess } from "../deal-settings-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {

  groups: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Group(s)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT_NESTED,
        mapNestedRows: data => groupsMapNestedRows(data),
        map: data => defaultField(data, "name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [,
          { map: row => get(row, "allocationPercent") },
          { map: row => get(row, "isPrimary") }]
      }
    ]
  },
  collabGroups: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Collaborators",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT_NESTED,
        mapNestedRows: data => collabGroupsMapNestedRows(data),
        map: data => defaultField(data, "name"),
        Cell: tableSideColumnMapper,
        subtextMappers: []
      }
    ]
  },
  sponsorCompanyId: {
    isVisible: data => hasBrokerAccess(data),
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Sponsor Company", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "sponsorCompany.name"), Cell: tableSideColumnMapper }
    ]
  }
};
